/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BookingRewardAuditItem } from './BookingRewardAuditItem';
import {
    BookingRewardAuditItemFromJSON,
    BookingRewardAuditItemFromJSONTyped,
    BookingRewardAuditItemToJSON,
    BookingRewardAuditItemToJSONTyped,
} from './BookingRewardAuditItem';

/**
 *
 * @export
 * @interface BookingRewardAuditResponse
 */
export interface BookingRewardAuditResponse {
    /**
     *
     * @type {Array<BookingRewardAuditItem>}
     * @memberof BookingRewardAuditResponse
     */
    items: Array<BookingRewardAuditItem>;
}

/**
 * Check if a given object implements the BookingRewardAuditResponse interface.
 */
export function instanceOfBookingRewardAuditResponse(value: object): value is BookingRewardAuditResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function BookingRewardAuditResponseFromJSON(json: any): BookingRewardAuditResponse {
    return BookingRewardAuditResponseFromJSONTyped(json, false);
}

export function BookingRewardAuditResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingRewardAuditResponse {
    if (json == null) {
        return json;
    }
    return {

        'items': ((json['items'] as Array<any>).map(BookingRewardAuditItemFromJSON)),
    };
}

export function BookingRewardAuditResponseToJSON(json: any): BookingRewardAuditResponse {
    return BookingRewardAuditResponseToJSONTyped(json, false);
}

export function BookingRewardAuditResponseToJSONTyped(value?: BookingRewardAuditResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'items': ((value['items'] as Array<any>).map(BookingRewardAuditItemToJSON)),
    };
}

